// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1jtCU","inner":"Footer_inner__8CWrq"};